class Common {
  constructor(el,opt){
    this.event();
  }
  event(){
    $('.js-drawer-trigger').on('click', function(){
      $('html').toggleClass('is-drawer-open');
      if($('html').hasClass('is-drawer-open')){
        $('.js-drawer-txt').text('CLOSE');
      } else {
        $('.js-drawer-txt').text('MENU');
      }
      scrollBan();
    });
  }
}
